import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { tokenStorage } from '@/lib/tokens';
import { useLogoutMutation, useMeQuery } from '@/store/api/authApi';
import { authActions } from '@/store/slices/authSlice';
import { useAppDispatch, useAppSelector } from '@/store/hooks';

export function useAuth() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const me = useAppSelector((state) => state.auth.me);
  const hydrated = useAppSelector((state) => state.auth.hydrated);
  const hasToken = Boolean(tokenStorage.getAccess());
  const { data, isFetching, isError } = useMeQuery(undefined, { skip: !hasToken });
  const [logoutMutation] = useLogoutMutation();

  useEffect(() => {
    if (data) {
      dispatch(authActions.setMe(data));
    } else if (!hasToken) {
      dispatch(authActions.setHydrated());
    } else if (isError) {
      dispatch(authActions.logout());
      tokenStorage.clear();
    }
  }, [data, dispatch, hasToken, isError]);

  const logout = async () => {
    try {
      await logoutMutation().unwrap();
    } catch {
      // Network errors ignored on logout
    }
    tokenStorage.clear();
    dispatch(authActions.logout());
    navigate('/login', { replace: true });
  };

  return {
    me: me ?? data ?? null,
    isLoading: hasToken && (isFetching || !hydrated),
    isAuthenticated: Boolean(me ?? data) && hasToken,
    logout,
  };
}
